export var ReactNativeFile = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    name = _ref.name,
    type = _ref.type
  this.uri = uri
  this.name = name
  this.type = type
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-files/lib/ReactNativeFile.mjs
// module id = 329
// module chunks = 0